import { colors, InputText } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const TemplateInputNameStyled = styled(InputText)`
  padding: 0 1.2rem 3.6rem;
`;

export const TemplateNameStyled = styled.b`
  margin: 0 0.5rem;
  color: ${colors.neutral[900]};
`;
